import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params, UrlSegment } from '@angular/router';
import { Router, NavigationEnd, ResolveEnd } from '@angular/router';
import { Location } from '@angular/common'
import { Subject } from "rxjs";
import { Product, ProductResponse } from '../../../models/Product';
import { ProductService } from "../../../services/product.service";
import { User } from '../../../models/User';
import { AuthService } from '../../../services/auth.service';
import { AdminUrlType } from "../../../services/utility/general-helper.service";
import * as $ from 'jquery';


// enum AdminUrlType{
//   Dashboard,
//   ProductList,
//   ProductAdd,
//   ProductEdit,
//   Customers
// }

@Component({
  selector: 'app-admin-products',
  templateUrl: './admin-products.component.html',
  styleUrls: ['./admin-products.component.scss']
})
export class AdminProductsComponent implements OnInit {
  AdminUrlType = AdminUrlType;
  @Input('urlType') urlType:AdminUrlType;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  products: Product[];  //initially null until http_getProducts responds.  Will be passed down as input to children.
  product:Product;
  user: User;  //initially null.  Will be passed down to children's inputs.
  // category:string = null;
  // category_formatted:string = null;
  sku:string = null;

  constructor(   
    private route:ActivatedRoute,
    private router:Router,
    private location:Location,
    private productService:ProductService,
    private authService:AuthService
  ) { }

  //Shall match products.component
  ngOnInit() {
    // console.log('ap-init');
        //1 - load products once
    //2 - then evaluate the url on each change
    //3 - merge the results with one/first observation of params.
    //4 - merge the results with an Observable of each new 'products' received.  In case a product was edited causing productService.product$ to refresh
    this.productService.loadAllProducts(true).first()
    .flatMap( () => {
      // console.log('new url/params combo.  combine with observable of products stream.', result);
      return this.productService.product$;
    })
    .mergeMap( (products:Product[]) => {
      return this.authService.user$.map((user:User) => {
        return {products:products, user:user}
      });
    })
    .mergeMap(
      (results:{products:Product[], user:User}) => {
        // console.log('new url.  combine with params at this url.');
        return this.route.params.first().map((params:Params) => { return {products:results.products, user:results.user, params:params} });
      }
    )
    .takeUntil(this.ngUnsubscribe)
    .subscribe( (result:{products:Product[], user:User, params:Params}) => { 
      // console.log('admin-products: new result', result);
      // console.log('merged with products received updated products: ', result.products);
      //use url / params to set local variables
      // let url = result.url;
      // let params = result.params;
      // this.category = params["category"];
      this.sku = result.params["sku"];
      // this.urlType = this.getAdminUrlType(url, this.sku);
      // this.category_formatted = this.getCategoryFormatted(this.category);
      //assign the product, or null if no sku
      this.product = this.productService.getProductBySku(this.sku);
      //assign the user (can be null)
      this.user = result.user;
      // console.log('user', this.user);


      //filter products
      // let filteredProducts = this.productService.getProductsByCategory(this.category); 
      // console.log('filtered products', filteredProducts);
      // let activeProducts = Product.filterActiveProducts(filteredProducts);
      // console.log('activeProducts', activeProducts);
      this.products = result.products;      
      
    });
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}


//================
//Unused Code

// //Update: we don't need a copy of all products.  Instead, pass the single product down to the edit component, and in the edit component make the copy of the single product for editing.
// // this.products = products;  //NO! - assign a copy, so that we can keep track of edits
// // **this.products will be input to admin-product-list, which can edit product.active.
// //   So this.products MUST be a copy of productService.product$.value
// let productsCopy = Product.fromJsonList(products);
// this.products = productsCopy;


  // ngOnInit() {

  //   //only load the products here.  We later observe them for changes via this.productService.product$.
  //   this.productService.loadAllProducts(true)
  //   .first().subscribe((productResponse:ProductResponse) => {
  //     // console.log('productResponse', productResponse);
  //   });

  //   this.productService.product$
  //   .takeUntil(this.ngUnsubscribe)
  //   .subscribe(products => {
  //     console.log('admin-products received updated products: ', products);
  //     this.products = products;
  //   });
    
    
  // }


// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-products.component.ts